export default "__VITE_ASSET__170405b3__"